var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-eye-off';
                    var viewUrl = 'sprite.svg#view-icon-eye-off';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 31 17',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };